class FileLoadedController {

    formatSize(size) {
        if (size < 1024) return size + ' B';
        if (size < 1048576) return (size / 1024).toFixed(1) + ' KB';
        return (size / 1048576).toFixed(1) + ' MB';
    }
}

angular.module('cpm').component('fileLoadedControl', {
    templateUrl: 'components/file-uploader/file-loaded.html',
    controller: FileLoadedController,
    bindings: {
        file: '<',
        onDelete: '&'
    }
});
